<template>
  <div class="demand-operation-list">
    <el-descriptions :column="1" border size="small">
      <el-descriptions-item :label="$str.getKey('策略控制/分组索引')">
        {{ groupIndex }}
      </el-descriptions-item>
      <!-- 新增elinkId -->
      <el-descriptions-item label="elinkId">
        {{ elinkId }}
      </el-descriptions-item>
      <!-- 新增自动需量开关状态 -->
      <el-descriptions-item :label="$str.getKey('策略控制/自动需量开关')">
        {{ autoSwitchText }}
      </el-descriptions-item>
      <el-descriptions-item :label="$str.getKey('策略控制/需量预留值')">
        {{ protectiveValue }} kW
      </el-descriptions-item>
      <el-descriptions-item :label="$str.getKey('策略控制/需量起始值')">
        <div class="monthly-values">
          <div v-for="month in 12" :key="month" class="month-item">
            <span class="month-label" v-if="isZh">{{ month + $str.getKey('策略控制/月') }}：</span>
            <span class="month-label" v-else>{{ getMonthEn(month) }}：</span>
            <span class="month-value">{{ getMonthlyValue(month) }}</span>
          </div>
        </div>
      </el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { computed } from 'vue'
const $str = window.$str;

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  }
})

// 获取指定月份的值
function getMonthlyValue(month) {
  // 优先处理新的数组格式
  if (props.data.monthly && Array.isArray(props.data.monthly)) {
    return props.data.monthly[month - 1] || 0
  }
  
  // 处理旧的monthlyArr格式
  if (props.data.monthlyArr && Array.isArray(props.data.monthlyArr)) {
    return props.data.monthlyArr[month - 1] || 0
  }
  
  // 处理旧的JSON对象格式
  if (props.data.monthly && typeof props.data.monthly === 'object' && !Array.isArray(props.data.monthly)) {
    return props.data.monthly[month] || 0
  }
  
  // 尝试从字符串解析
  if (typeof props.data.monthly === 'string') {
    try {
      const monthlyObj = JSON.parse(props.data.monthly)
      // 判断解析后的是数组还是对象
      if (Array.isArray(monthlyObj)) {
        return monthlyObj[month - 1] || 0
      } else {
        return monthlyObj[month] || 0
      }
    } catch (e) {
      console.error('解析monthly字符串失败:', e)
    }
  }
  
  return 0
}

// 获取分组索引
const groupIndex = computed(() => {
  return props.data.groupIndex || props.data.group_index || '--'
})

// 获取预留值
const protectiveValue = computed(() => {
  return props.data.protectiveValue || props.data.protective_value || 0
})

// 获取elinkId
const elinkId = computed(() => {
  const uuidList = props.data.uuidList || props.data.uuid_list || []
  
  // 如果是数组，转换为逗号分隔的字符串
  if (Array.isArray(uuidList)) {
    return uuidList.join(', ')
  }
  
  // 如果是字符串，直接返回
  if (typeof uuidList === 'string') {
    return uuidList
  }
  
  return '--'
})

// 获取自动需量开关状态
const autoSwitchText = computed(() => {
  const autoSwitch = props.data.autoSwitch || props.data.auto_switch
  
  switch (autoSwitch) {
    case -1:
      return $str.getKey('策略控制/关闭')
    case 0:
      return $str.getKey('策略控制/关闭')
    case 1:
      return $str.getKey('策略控制/开启')
  }
})
const isZh = computed(() => $str.getLanguage() === 'cn')
function getMonthEn(index){
  const monthEn = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  return monthEn[index-1]
}
</script>

<style lang="scss" scoped>
.demand-operation-list {
  max-width: 100%;

  .monthly-values {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;

    .month-item {
      display: flex;
      align-items: center;
      font-size: 12px;

      .month-label {
        color: rgba(0, 0, 0, 0.5);
        margin-right: 4px;
        min-width: 30px;
      }

      .month-value {
        color: #2e2e2e;
        font-weight: 500;
      }
    }
  }
}

:deep(.el-descriptions) {
  background: transparent;
  width: 100%;

  .el-descriptions__header {
    display: none;
  }

  .el-descriptions__body {
    background: transparent;
  }

  .el-descriptions__table {
    background: transparent;
    table-layout: fixed;
    width: 100%;
  }

  .el-descriptions__cell {
    background: #ffffff;
    border-color: rgba(0, 0, 0, 0.08);
    color: #2e2e2e;
    word-break: break-all;
    overflow-wrap: anywhere;

    &.el-descriptions__label {
      background: rgba(43, 87, 238, 0.04);
      color: rgba(0, 0, 0, 0.5);
      font-weight: 500;
      width: 96px;
    }
  }
}
</style> 